<script>
export default {
  props: ['total']
}
</script>

<template>
  <div class="total-amount is-cs-2">
    <div class="has-text-right">
      <span class="is-cs-4">
        <small class="is-cs-6">ウィッシュリスト</small>
        <span>合計予算</span>
        <em>{{ total.amount.toLocaleString() }}</em>
        円
      </span>
    </div>
    <router-link v-if="total.quantity > 0" :to="{name: 'qrcode-order'}">
      <button class="button is-rounded is-c-primary is-cs-2">QRを表示</button>
    </router-link>
    <a v-else>
      <button class="button is-rounded is-cs-2 is-c-primary" disabled>QRを表示</button>
    </a>
  </div>
</template>

<style scoped>
.total-amount {
  position: fixed;
  bottom:0; left:0;
  color: #d6d6d6;
  width: 100%;
  height: 6rem;
  background-color: #3d3d3d;
  box-shadow: 0px -2px 9px rgba(0, 0, 0, 0.26), inset 0px 2px 0px #04E0EE;
  padding: 1rem;
  z-index: 30;
}
.total-amount > div {
  padding-right: 7.5rem;
}
.total-amount > div > span {
  vertical-align: baseline;
}
.total-amount > div > span > small {
  position: absolute;
  top: 1rem;
  left: 1rem;
}
.total-amount div > span em {
  display: inline-block;
  width: calc(100% - 5rem);
  font-size: 2.5rem;
  line-height: 4rem;
}
.total-amount a {
  position: absolute;
  top: 1.5rem; right: 1rem;
}
.total-amount button {
  width: 6.75rem;
  height: 3rem;
  color: #fff;
}
.total-amount button[disabled] {
  color: #3d3d3d;
}
</style>



// WEBPACK FOOTER //
// src/components/view/total-amount.vue